// import logo from './logo.svg';
import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import About from "./components/About";
import Signup from "./components/Signup";
import Login from "./components/Login";
import ChamberClass from "./components/ChamberClass";
import PrivateRoute from "./components/PrivateRoute";
import AdminRoute from "./components/AdminRoute";
import SuperAdminRoute from "./components/SuperAdminRoute";
import Dashboard1 from "./components/NewDashboard";
import HospitalsClass from "./components/HospitalsClass";

import NavBar from "./components/NavBar";

// import RealtimeGraph from "./components/RealtimeGraph";

// import { FiSquare } from "react-icons/fi";
// import { BsFillSquareFill } from "react-icons/bs";
import { Container } from "react-bootstrap";

// import firebase from './firebase.js'

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";

import "./App.css";
import { AuthProvider } from "./contexts/AuthContext";
import ChartsClass from "./components/ChartsClass";
import ResponsiveDrawer from "./components/ResponsiveDrawer";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { classes } from "istanbul-lib-coverage";
import GraphTest from "./components/GraphTest";
import HomePage from "./components/HomePage";
import CentralDashboard from "./components/CentralDashboard";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },

  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: drawerWidth,
      paddingTop: 67,
      //paddingLeft: '5%',
      //paddingRight: '5%',
      textAlign: "center",
      maxWidth: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      paddingTop: 50,
    },
    [theme.breakpoints.up("md")]: {
      //paddingLeft: '15%',
      //paddingRight: '15%',
    },
  },
}));

function App() {
  const classes = useStyles();
  return (
    <>
      <Router>
        {/* <NavBar/> */}
        <AuthProvider>
          <Switch>
            <Route exact path="/">
              <HomePage />
            </Route>
            <SuperAdminRoute exact path="/signup"
              render={()=><Signup />}>
            </SuperAdminRoute>

            <Route exact path="/login">
              <Login />
            </Route>

            <div className={classes.content}>
              <ResponsiveDrawer />

              <PrivateRoute
                exact
                path="/dash1"
                render={() => <Dashboard1/>}>
              </PrivateRoute>

              <SuperAdminRoute exact path="/hospitals"
                 render={() => <HospitalsClass/>}>
              </SuperAdminRoute>

              <SuperAdminRoute exact path="/central-dashboard"
                 render={() => <CentralDashboard/>}>
              </SuperAdminRoute>

              <Route exact path="/navbar">
                <NavBar />
              </Route>

              <Route exact path="/graphtest">
                <GraphTest />
              </Route>

              {/* <Route exact path="/rtgraph">
                <RealtimeGraph />
              </Route> */}

              <Route exact path="/drawer">
                <ResponsiveDrawer />
              </Route>

              <PrivateRoute
                exact
                path="/hospitals/:hospitalId/:roomId"
                render={({ match }) => <ChartsClass match={match} />}
              ></PrivateRoute>

              <Route exact path="/about">
                <About />
              </Route>

              <AdminRoute exact path="/hospitals/:id"
                render={() =><ChamberClass />}
              ></AdminRoute>
            </div>
          </Switch>
        </AuthProvider>

        <Footer />
      </Router>
    </>
  );
}

export default App;